import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Table, Button, Tooltip, Divider, Popconfirm } from 'antd'
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons'
import 'jspdf-autotable'
import './styles.css'

const { Column } = Table

const InventoryVehiclesTable = ({ data, onRemoveVehicle, onEditVehicle, onShowReservations, loading }) => {
    const didTapShowReservations = record => {
        onShowReservations(record)
    }

    const didTapEditInventory = record => {
        onEditVehicle(record)
    }

    const didTapRemoveInventory = record => {
        onRemoveVehicle(record)
    }

    return (
        <Table className="inventyTableCont" dataSource={data} rowKey="id" size="small" pagination={true}
               scroll={{ x: 1200 }}>
            <Column title="Nombre" dataIndex="name" key="name" align="center" width="20%"/>
            <Column title="Kilómetros" dataIndex="kilometres" key="kilometers" align="center" width="20%"/>
            <Column title="Patente" dataIndex="plate" key="plate" align="center" width="20%"/>
            <Column title="Combustible" dataIndex="fuelQuantity" key="fuelQuantity" align="center" width="20%"/>
            <Column title="Acción" dataIndex="id" key="id" align="center" width="20%"
                    render={(text, record) => {
                        return (
                            <div>
                                <Tooltip title="Ver reservas">
                                    <Button loading={loading} onClick={() => didTapShowReservations(record)}
                                            icon={<EyeOutlined style={{ color: 'green' }}/>}/>
                                </Tooltip>
                                <Divider type="vertical"/>
                                <Tooltip title="Editar vehículo">
                                    <Button loading={loading} onClick={() => didTapEditInventory(record)}
                                            icon={<EditOutlined style={{ color: 'blue' }}/>}/>
                                </Tooltip>
                                <Divider type="vertical"/>
                                <Tooltip title="Borrar vehículo">
                                    <Popconfirm disabled={loading} title="Se borrará el vehículo, ¿Continuar?"
                                                onConfirm={() => didTapRemoveInventory(record)}>
                                        <Button loading={loading} icon={<DeleteOutlined style={{ color: 'red' }}/>}/>
                                    </Popconfirm>
                                </Tooltip>
                            </div>
                        )
                    }}/>
        </Table>
    )
}

InventoryVehiclesTable.propTypes = {
    data: PropTypes.array
}

export default InventoryVehiclesTable
